import { JSX } from "react";
import { Spinner as ReactstrapSpinner } from "reactstrap";

const Spinner = (): JSX.Element => (
    <ReactstrapSpinner
        color="primary"
        className='position-absolute'
        style={{ top: 'calc(50% - 13px)', left: 'calc(50% - 13px)', zIndex: 1001,}}
    />
);

export default Spinner;
